import { useState, useEffect } from 'react';
import { IoMdClose } from 'react-icons/io';
import toast from 'react-hot-toast';
import { FaArrowLeftLong } from 'react-icons/fa6';

import TriggerModal from './TriggerModal';
import QuestionForm from './QuestionForm';
import { DataState } from './../../context/DataProvider';
import { submitWorkflowAndGetClarificationQuestions } from './../../services/workflowApi';
import TriggerModalNew from './TriggerModalNew';
import { integrationData, triggerOptionsNew } from '../../utils/constants';
import Button from '../custom/Button';
import SelectedTriggerItem from './SelectedTriggerItem';
import DataSourceModal from './DataSourceModal';
import { getFileIcon } from '../chat/AttachmentIcon';

const AiWorkflowForm = ({
  /*isModalOpen,*/ closeModal,
  copyWorkflow = false,
  copyWorkflowData,
}) => {
  const [isTriggerModalOpen, setIsTriggerModalOpen] = useState(false);
  const [isIntegrationModalOpen, setIsIntegrationModalOpen] = useState(false);
  // const [isDataSourceModalOpen, setIsDataSourceModalOpen] = useState(false);

  const [selectTrigerOptions, setSelectTrigerOptions] = useState([]);
  const [selectIntegrationOptions, setSelectIntegrationOptions] = useState([]);
  const [selectDataSourceOptions, setSelectDataSourceOptions] = useState([]);
  const [isDataSourceSelectionModalOpen, setIsDataSourceSelectionModalOpen] =
    useState(false);

  // const [allDataSources, setAllDataSources] = useState([]);
  const [selectedDataSourceFiles, setSelectedDataSourceFiles] = useState([]);
  const [clarificationQuestions, setClarificationQuestions] = useState([]);
  const [workflowId, setWorkflowId] = useState('');

  const { userGoogleId } = DataState();
  const [editOption, setEditOption] = useState(null);
  const [triggerName, setTriggerName] = useState(''); // State for storing the trigger name
  const [instruction, setInstruction] = useState(''); // State for storing the instruction

  const handleDataSourceModalClose = () => {
    setIsDataSourceSelectionModalOpen(false);
  };

  const handleDeleteOption = (optionId) => {
    setSelectTrigerOptions((prev) =>
      prev.filter((item) => item.id !== optionId),
    );
  };
  const handleDeleteIntegrationOption = (optionId) => {
    setSelectIntegrationOptions((prev) =>
      prev.filter((item) => item.id !== optionId),
    );
  };

  const handleTriggerEditOption = (option) => {
    setEditOption(option);
    setIsTriggerModalOpen(true);
  };
  const handleIntergrationEditOption = (option) => {
    setEditOption(option);
    setIsIntegrationModalOpen(true);
  };

  // const handleDataSourceEditOption = (option) => {
  //   setEditOption(option);
  //   setIsDataSourceModalOpen(true);
  // };

  const [showQuestionForm, setShowQuestionForm] = useState();
  const [showTestScreen, setShowTestScreen] = useState();
  const [isFormLoading, setIsFormLoading] = useState(false);
  const clearStates = () => {
    setSelectTrigerOptions([]);
    setSelectIntegrationOptions([]);
    setSelectDataSourceOptions([]);
    setTriggerName('');
    setInstruction('');
  };

  const createWorkflowAndGetClarificationQuestions = async (
    instruction,
    name,
    trigger,
    apps,
    dataSources,
  ) => {
    try {
      // Create the task bot
      // Extract file IDs to send to the API
      const selectedFileIds = selectedDataSourceFiles.map(
        (file) => file.file_id,
      );

      const botResponse = await submitWorkflowAndGetClarificationQuestions(
        userGoogleId,
        instruction,
        name,
        trigger,
        apps,
        selectedFileIds,
      );

      if (botResponse.error) {
        throw new Error(botResponse.error);
      }
      // setClarificationQuestions(botResponse.questions)
      // setCurrentBot(botResponse.bot);
      setWorkflowId(botResponse.workflow_id || '');
      // Check if there are any clarification questions
      if (botResponse.questions && botResponse.questions.length > 0) {
        // Save the clarification questions in the state
        // Transform the list of questions into a list of objects with question and answer keys

        const formattedQuestions = botResponse.questions.map((question) => ({
          id: question.id,
          question: question.question,
          answer: '',
        }));

        // Save the clarification questions in the state

        setClarificationQuestions(formattedQuestions);

        // setClarificationQuestions(botResponse.questions);
      }

      return botResponse;
    } catch (error) {
      toast.error(
        'Error in creating task bot and handling clarification questions',
      );

      throw error;
    }
  };

  const handleNewInstructionSubmission = async () => {
    setIsFormLoading(true);
    try {
      const final_response = await createWorkflowAndGetClarificationQuestions(
        instruction,
        triggerName,
        selectTrigerOptions,
        selectIntegrationOptions,
        selectDataSourceOptions,
      );
      if (final_response && final_response.questions) {
        setShowQuestionForm(true);
      }
    } catch (error) {
    } finally {
      setIsFormLoading(false);
    }
  };
  const handleShowTestScreen = () => {
    setShowTestScreen(true);
  };

  useEffect(() => {
    if (copyWorkflow) {
      setInstruction(copyWorkflowData.task_description);
      setSelectTrigerOptions(copyWorkflowData.trigger);
      setSelectIntegrationOptions(copyWorkflowData.apps_expanded);
      setSelectDataSourceOptions(copyWorkflowData.dataSources);
    }
    // eslint-disable-next-line
  }, [copyWorkflow]);

  return (
    <div
      className={`fixed left-0 top-0 z-[100] h-screen w-screen items-center justify-center bg-black bg-opacity-20 backdrop-blur-sm transition-all duration-200 ease-in-out ${
        true ? 'flex' : 'hidden'
      }`}
    >
      {!showTestScreen && !showQuestionForm && (
        <div className="bg-1 h-[90%] w-[90%] max-w-3xl overflow-auto rounded-lg">
          <div className="br-1 text-p-text flex justify-between gap-3 border-b px-3 py-5">
            <input
              className="text-p-text bg-2 w-fit resize-none rounded-lg px-3 py-1.5 text-center text-xl font-bold outline-none"
              value={triggerName}
              onChange={(e) => setTriggerName(e.target.value)}
              placeholder="Untitled Workflow"
            />
            <div>
              <button
                onClick={closeModal}
                className="bg-1 rounded-lg p-1.5 transition-all duration-200"
              >
                <IoMdClose />
              </button>
            </div>
          </div>
          <div className="flex flex-col gap-8 p-6">
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-3 rounded-lg bg-zinc-950 px-3 py-2">
                <div className="flex flex-col gap-1 ">
                  <h1 className="text-base font-semibold">Triggers</h1>
                  <p className="text-p-text text-sm">
                    Events that automatically initiates the workflow
                  </p>
                </div>

                <button
                  onClick={() => setIsTriggerModalOpen(true)}
                  className="rounded-lg border border-zinc-200 px-2 py-1 text-sm transition-all duration-200"
                >
                  ADD
                </button>
              </div>

              {selectTrigerOptions.map((item) => (
                <SelectedTriggerItem
                  item={item}
                  handleEditOption={() => handleTriggerEditOption(item)}
                  handleDeleteOption={handleDeleteOption}
                />
              ))}
            </div>
            <div className="flex flex-col gap-1">
              <div className="flex flex-col gap-1">
                <h1 className="text-base font-semibold">
                  Workflow Instructions
                </h1>
              </div>
              <textarea
                value={instruction}
                onChange={(e) => setInstruction(e.target.value)} // Update instruction state
                className="r h-52 resize-none rounded-lg border border-zinc-500 bg-transparent px-4 py-2 text-base outline-none"
                placeholder="Instructions describe your workflow requirements in detail. Include all necessary steps, data processing instructions, and desired outcomes across integrated applications (e.g. Jira, Email, Sheets, Docs). Example: 'For every email received in the inbox, send an automated apology response explaining a 34 hour delay in support. Then, create a Jira task under the 'Support' Project, including the email content and tagging it as 'High Priority'. Notify the team lead in Slack once task is created."
              />
            </div>

            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-3 rounded-lg bg-zinc-950 px-3 py-2">
                <div className="flex flex-col gap-1 ">
                  <h1 className="text-base font-semibold">App integrations</h1>
                  <p className="text-sm">
                    Add applications included in the workflow
                  </p>
                </div>
                <button
                  onClick={() => setIsIntegrationModalOpen(true)}
                  className="rounded-lg border border-zinc-200 px-2 py-1 text-sm transition-all duration-200"
                >
                  ADD
                </button>
              </div>
              {selectIntegrationOptions.map((item) => (
                <SelectedTriggerItem
                  item={item}
                  handleEditOption={() => handleIntergrationEditOption(item)}
                  handleDeleteOption={handleDeleteIntegrationOption}
                />
              ))}
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-3 rounded-lg bg-zinc-950 px-3 py-2">
                <div className="flex flex-col gap-1 ">
                  <h1 className="text-base font-semibold">Data sources</h1>
                  <p className="text-sm">
                    Add data sources required in the workflow
                  </p>
                </div>
                <button
                  onClick={() => setIsDataSourceSelectionModalOpen(true)}
                  className="rounded-lg border border-zinc-200 px-2 py-1 text-sm transition-all duration-200"
                >
                  ADD
                </button>
              </div>
              {
                <ul className="flex flex-wrap gap-2">
                  {selectedDataSourceFiles.length > 0 &&
                    selectedDataSourceFiles.map((file, idx) => (
                      <li
                        key={idx}
                        className="text-s-text rounded-full bg-zinc-100 px-3 py-1.5 text-sm text-zinc-800"
                      >
                        <div className="flex max-w-[70%] items-center gap-2">
                          {/* <FaFile className="text-white" /> */}
                          {getFileIcon(file.original_filename)}
                          <span
                            className="cursor-pointer truncate text-sm transition-all hover:max-w-none hover:overflow-visible hover:whitespace-normal"
                            title={`${file.original_filename}\nUploaded at: ${file.timestamp}`}
                          >
                            {file.original_filename}
                          </span>
                        </div>
                      </li>
                    ))}
                </ul>
              }
            </div>

            <div className="flex justify-end">
              <Button
                loading={isFormLoading}
                onClick={handleNewInstructionSubmission}
              >
                Continue
              </Button>
            </div>

            <TriggerModalNew
              title="Add trigger"
              desc="Give your assistant access to Oqlous actions."
              isOpen={isTriggerModalOpen}
              onClose={() => {
                setIsTriggerModalOpen(false);
                setEditOption(null);
              }}
              appsData={triggerOptionsNew}
              selectedOptions={selectTrigerOptions}
              setSelectedOptions={setSelectTrigerOptions}
              editOption={editOption}
            />
            <TriggerModal
              title="Add integration"
              desc=" Select the app you’d like to add as integration."
              isOpen={isIntegrationModalOpen}
              onClose={() => {
                setIsIntegrationModalOpen(false);
                setEditOption(null);
              }}
              appsData={integrationData}
              selectedOptions={selectIntegrationOptions}
              setSelectedOptions={setSelectIntegrationOptions}
              editOption={editOption}
            />

            {isDataSourceSelectionModalOpen && (
              <DataSourceModal
                closeModal={handleDataSourceModalClose}
                setSelectedDataSourceFiles={setSelectedDataSourceFiles}
                selectedDataSourceFiles={selectedDataSourceFiles}
              />
            )}
          </div>
        </div>
      )}
      {showQuestionForm && !showTestScreen && (
        <div className="h-[90%] w-[90%] max-w-3xl overflow-auto rounded-lg bg-zinc-900">
          <div className="flex justify-between gap-3 border-b border-zinc-800 px-3 py-5">
            <div className="flex items-center gap-3 bg-transparent px-3 py-1.5 text-xl font-bold">
              <button
                onClick={() => setShowQuestionForm(false)}
                className="bg-2 rounded-lg p-1.5 transition-all duration-200"
              >
                <FaArrowLeftLong />
              </button>
              Clarification Questions
            </div>
            <div></div>
          </div>
          <div className="flex flex-col gap-8 p-6">
            <QuestionForm
              handleShowTestScreen={handleShowTestScreen}
              clarificationQuestions={clarificationQuestions}
              closeModal={closeModal}
              setShowQuestionForm={setShowQuestionForm}
              clearStates={clearStates}
              workflowId={workflowId}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AiWorkflowForm;
